




import Component from "vue-class-component";
import { BaseRootPageComponent } from "@/components/BaseRootPageComponent";

@Component
export default class NoAccess extends BaseRootPageComponent {}
